<template>
  <div class="pageContent" style="position:absolute;">
    <pageTitle title='储值卡支付' />

    <div style=" width:100% " align="center">
      <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; margin:2.1rem auto 0 auto" v-show="  IsLoading  " />
    </div>
    
    <div v-show="!IsLoading">
      <inputBox :disabled='true' label='会员账号' :value='OrderMess.Cardno' />
      <inputBox :disabled='true' label='手机号码' :value='OrderMess.PhoneNo' />
      <inputBox :disabled='true' label='支付金额' :value='"￥"+OrderMess.TotalMoney' />
      <inputBox label='支付密码' :secret='true' v-model="PayPass" hintMsg='请输入支付密码' />
      <inputBox label='附加码' v-model="FJM" hintMsg='请输入附加码' extendType='icon' :extendSrc='TPFJM' @extendHandler='getValidateCode'/>
      <inputBox label='验证码' v-model="YZM" hintMsg='请输入验证码' extendType='button' extendSrc='获取验证码' @extendHandler='getYZM' :countDownSeconds='countDown'/>
      <div v-if=" OrderMess.InvoiceOpened == true && OrderMess.SCOpened == true " style="text-align:center">
        <mu-select-field v-model="PayTypeTmp" label="选择储值卡账户类型" style="width:7.1rem;text-align:left">
          <mu-menu-item v-for="text,index in PayTypes" :key="index" :value="index" :title="text" />
        </mu-select-field>
        
        <div v-if=" OrderMess.InvoiceOpened == true && OrderMess.SCOpened == false ">
          储值卡(充值开票帐户)支付 ( {{ OrderMess.SCInvoiceMoney }} 元)
        </div>

        <div v-if=" OrderMess.InvoiceOpened == false && OrderMess.SCOpened == true ">
          储值卡(充值开票帐户)支付 ( {{ OrderMess.SCMoney }} 元)
        </div>
        <mu-raised-button label="立即支付" primary="" v-bind:style="{ width:'92%', height:'0.9rem' }" style="font-size: 0.3rem ; " v-on:click="PayByStoreCard" />
      </div>
    </div>

    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message='TellUser' @close="hideToast" id="alertline" />

  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'
import getDate from '../../utils/dateextend.js'

export default {
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_PayOrder'
    ])
  },
  data() {
    return {
      IsLoading: true,
      // 弹出层
      toast: false,
      TellUser: '',
      PayPass: '',
      FJM: '',
      YZM: '',
      TPFJM: '',
      OrderMess: '',
      PayTypes: [],
      // 0=false=  SCOpened    =  消费开票账户
      // 1=true= InvoiceOpened =  充值开票账户
      PayTypeTmp: -1,
      PayType: false,
      //倒计时时间
      countDown: 0
    }
  },
  activated() {
    this.init();
  },

  methods: {
    init() {
      this.IsLoading = true;

      this.GetValuePay();
      this.PayPass = '';
      this.FJM = '';
      this.YZM = '';
      this.TPFJM = '';
      this.getValidateCode();

    },

    // 图片验证码
    getValidateCode() {
      this.TPFJM = api.getValidateCode();
    },

    // 获取储值卡的账户信息
    GetValuePay() {

      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      if(this.$route.query.orderType){
        params.append('orderType',this.$route.query.orderType)
      }
      this.$http.post(api.GetValuePay(), params.toParam()).then((res) => {

        if (res.Result) {
          // 储值卡支付 - 信息展示
          this.OrderMess = res.Data;
          // 更新价格
          // var Order = this.g_PayOrder;
          // Order.Money = res.Data.TotalMoney;
          // this.setG_PayOrder( Order );

          // 只要把回传类型确定
          if (this.OrderMess.InvoiceOpened == true && this.OrderMess.SCOpened == false) {
            PayType = true;
          }
          else if (this.OrderMess.InvoiceOpened == false && this.OrderMess.SCOpened == true) {
            PayType = false;
          }
          else if (this.OrderMess.InvoiceOpened == true && this.OrderMess.SCOpened == true) {
            this.PayTypes[0] = '(消费开票帐户)支付 (' + this.OrderMess.SCMoney + ' 元)';
            this.PayTypes[1] = '(充值开票帐户)支付 (' + this.OrderMess.SCInvoiceMoney + ' 元)';
            // 这边的回传参数，在提交的地方决定
          }

          this.IsLoading = false;
        }
        else {
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },

    //  获取验证码
    getYZM() {
      if (this.FJM == '') {
        this.TellUser = '请输入附加码';
        this.showToast();
        this.countDown = 0
      }
      else {
        this.countDown = 30
        var params = new this.URLSearchParam();
        params.append('captcha', this.FJM);
        params.append('templateName', 'Pay');
        this.$http.post(api.sendSMSCode(), params.toParam()).then((res) => {
          console.log(res);

          if (res.Result) {
            this.TellUser = res.Data;
          }
          else {
            this.countDown = 5
            // this.TellUser = res.Message;
            
            if( res.Message=='验证码错误' ){
              this.TellUser = '附加码错误';
            }
            else{
              this.TellUser = res.Message;
            }
            this.getValidateCode();
          }
          this.showToast();
          // this.getValidateCode();
        })
      }
    },

    // 支付成功（失败）页面，底部标签跳转，评论列表结构修正，新增下拉刷新，用户评论页修复登出跳转，订单页修正结构，
    //  付钱去
    PayByStoreCard() {

      if (this.PayPass.length < 4) {
        this.TellUser = "请输入支付密码";
        this.showToast();
        return
      }
      else if (this.FJM.length < 4) {
        this.TellUser = "请输入附加码";
        this.showToast();
        return
      }
      else if (this.YZM.length < 4) {
        this.TellUser = "请输入验证码";
        this.showToast();
        return
      }

      if (this.PayTypeTmp == 0) {
        this.PayType = false;
      }
      else if (this.PayTypeTmp == 1) {
        this.PayType = true;
      }
      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      params.append('payPassword', this.PayPass);
      params.append('validateCode', this.YZM);
      params.append('needPayLog', 'true');
      params.append('isInvoice', this.PayType);
      if(this.$route.query.orderType){
        params.append('orderType',this.$route.query.orderType)
      }
      this.$http.post(api.PayByStoreCard(), params.toParam()).then((res) => {
        console.log(res);

        if (res.Result) {
          this.TellUser = res.Data;
          this.showToast();

          this.toastTimer1 = setTimeout(() => {
            this.$router.push({
              path: '/order/PayIsOk?result=true&money=' + this.OrderMess.TotalMoney + '&parentNo=' + this.g_PayOrder.OrderId
              + '&paytype=储值卡支付&payDate=' + Date.prototype.NowDate()+'&orderType='+this.$route.query.orderType
            });
          }, 1800);
        }
        else {
          this.TellUser = res.Message;
          this.showToast();

          // this.toastTimer1 = setTimeout(() => { 
          //   this.$router.push({ path: '/order/PayIsOk?result=false&message='+this.TellUser     }); 
          // }, 1800);
        }

      })
    },

    goback() {
      javascript: history.go(-1);
    },

    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
      // if (this.TellUser == '未登录' || this.TellUser == '服务器错误') {
      if (this.TellUser == '未登录' ) {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 2000)
      }
    },
  
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
  },
}
</script>





// WEBPACK FOOTER //
// PayByStoredValueCard.vue?7daee474